import { render, staticRenderFns } from "./listContents.vue?vue&type=template&id=4c810b6f&scoped=true"
import script from "./listContents.vue?vue&type=script&lang=js"
export * from "./listContents.vue?vue&type=script&lang=js"
import style0 from "./listContents.vue?vue&type=style&index=0&id=4c810b6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c810b6f",
  null
  
)

export default component.exports